import * as React from 'react'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { Container } from 'typescript-ioc/es5'
import { classnames } from '@halo/_utils/classnames'
import { Button, PageHeader } from '@pushly/aqe/lib/components'
import { PlatformMessageDto } from '@halo/dtos/platform-message.dto'
import './style/admin.scss'
import { PlatformMessageList } from '@halo/components/platform-message-form/platform-message-list'
import { noop } from '@pushly/aqe/lib/utils/noop'

interface IProps {}

interface IState {
    allMessages: PlatformMessageDto[]
    visibleMessages: PlatformMessageDto[]
}

export class PlatformMessages extends React.Component<IProps, IState> {
    protected appState: AppState
    protected appService: AppService
    private listRef = React.createRef<PlatformMessageList>()

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)
    }

    public render() {
        return (
            <div className={classnames('page')}>
                <div className={classnames('page-wrapper')}>
                    <div className="psmg-list">
                        <PageHeader
                            title="Messages"
                            onTitleSet={noop}
                            action={
                                <Button type="primary" onClick={() => this.listRef.current?.openDrawer()}>
                                    New Message
                                </Button>
                            }
                        />

                        <PlatformMessageList ref={this.listRef} hideCreateButton={true} />
                    </div>
                </div>
            </div>
        )
    }
}
